<template>
  <div v-if="isShowPage" class="collection">
    <div class="col-header">
      <!-- 导航 -->
      <van-nav-bar left-text left-arrow :title="lang.myFavourites" @click-left="onClickLeft" />
    </div>
    <!-- tab按钮 -->
    <van-tabs v-model="colIndex" title-active-color="#ED1C24" @click="handleTabClick">
      <van-tab v-if="isShowhistoryList" :title="lang.browseHistory" />
      <van-tab :title="lang.myFavourites">
        <div class="content">
          <van-tabs v-model="tabIndex" @click="clickSale">
            <van-tab :title="lang.esSale">
              <div slot="title" style="">
                {{ lang.esSale }}
              </div>
            </van-tab>
            <van-tab :title="lang.rent">
              <div slot="title" style="">
                {{ lang.rent }}
              </div>
            </van-tab>
            <van-tab :title="lang.newSale">
              <div slot="title" style="">
                {{ lang.newSale }}
              </div>
            </van-tab>
            <van-tab :title="lang.estate">
              <div slot="title" style="">
                {{ lang.estate }}
              </div>
            </van-tab>
          </van-tabs>
          <div
            v-if="showTab === 'sale' ? sellProperty.clearText : showTab === 'rent' ? rentProperty.clearText : showTab === 'estate' ? estProperty.clearText : newProperty.clearText"
            class="clear"
            @click="onClear"
          >
            <img src="../assets/clear.png" class="clearIcon" />
            {{ lang.clear }}
          </div>
        </div>
        <div>
          <div
            v-if="showTab === 'sale' ? sellProperty.showNull : showTab === 'rent' ? rentProperty.showNull : showTab === 'newestate' ? newProperty.showNull : estProperty.showNull"
            class="none-record"
          >
            <img src="//static.house730.com/m/images/none_col.png" :alt="lang.noInfo" class="none_col" />
            <p>{{ lang.noInfo }}</p>
          </div>
          <div v-else>
            <!-- 售列表 -->
            <div v-if="showTab === 'sale'">
              <van-list v-model="sellProperty.loading" :finished="sellProperty.finished" :loading-text="lang.loading" :finished-text="lang.noMore" @load="onload(sellProperty)">
                <historyList :house-list="sellProperty.list" :collection-list="true" @cancelCollection="cancelCollection" @canaddCollection="canaddCollection" />
              </van-list>
            </div>
            <!-- 租列表 -->
            <div v-if="showTab === 'rent'">
              <van-list v-model="rentProperty.loading" :finished="rentProperty.finished" :loading-text="lang.loading" :finished-text="lang.noMore" @load="onload(rentProperty)">
                <historyList :house-list="rentProperty.list" :collection-list="true" @cancelCollection="cancelCollection" @canaddCollection="canaddCollection" />
              </van-list>
            </div>
            <!-- 新房列表 -->
            <div v-if="showTab === 'newestate'">
              <van-list v-model="newProperty.loading" :finished="newProperty.finished" :loading-text="lang.loading" :finished-text="lang.noMore" @load="onload(newProperty)">
                <newList :house-list="newProperty.list" @cancelCollection="cancelCollection" />
              </van-list>
            </div>
            <!-- 屋苑列表 -->
            <div v-if="showTab === 'estate'">
              <van-list v-model="estProperty.loading" :finished="estProperty.finished" :loading-text="lang.loading" :finished-text="lang.noMore" @load="onload(estProperty)">
                <estList :house-list="estProperty.list" @cancelCollection="cancelCollection" />
              </van-list>
            </div>
          </div>
        </div>
        <!-- 点击清除出现的蒙版 -->
        <van-dialog
          v-model="showClear"
          :title="lang.delColTit"
          show-cancel-button
          :confirm-button-text="lang.confirmButtonText"
          :cancel-button-text="lang.cancelButtonText"
          :overlay="false"
          :before-close="beforeClose"
        />
        <div v-show="showClear" class="popup-clear" />
        <!-- 底部弹出 -->
        <!-- eslint-disable-next-line vue/no-v-model-argument, vue/valid-v-model, vue/max-attributes-per-line -->
        <van-popup v-model:show="showBottom" position="bottom" :style="{ height: '60px', background: '#4C4C4C', textAlign: 'left' }" :overlay="false" :lock-scroll="false">
          <span class="vanPopupCount">{{ count }} </span>
        </van-popup>
      </van-tab>
      <van-tab :title="lang.subscribe" />
    </van-tabs>
  </div>
</template>

<script>
// import { Toast } from 'vant';
import pub from '../../common/public';
import lang from './../../common/language/history';
import '../../common/css/common.scss';
import historyList from '../components/history-list';
import estList from '../components/est-list';
import newList from '../components/new-list';
export default {
  metaInfo: { title: lang.myFavourites },
  name: 'Collection',
  components: {
    // [Toast.name]: Toast,
    historyList,
    newList,
    estList,
  },
  data() {
    return {
      collectionListAll: 0,
      collection_List: true,
      popupTimer: null,
      count: '',
      showBottom: false,
      propertyListId: [],
      colIndex: 1,
      isShowPage: false,
      isPc: false,
      lang: lang,
      showTab: '',
      // 点击清除显示蒙版
      showClear: false,
      // 加载更多
      sellProperty: {
        list: [],
        clearText: '',
        loading: false,
        finished: false,
        pageIndex: 1,
        showNull: false, //是否展示空白
      },
      rentProperty: {
        list: [],
        clearText: '',
        loading: false,
        finished: false,
        pageIndex: 1,
        showNull: false, //是否展示空白
      },
      newProperty: {
        list: [],
        clearText: '',
        loading: false,
        finished: false,
        pageIndex: 1,
        showNull: false, //是否展示空白
      },
      estProperty: {
        list: [],
        clearText: '',
        loading: false,
        finished: false,
        pageIndex: 1,
        showNull: false, //是否展示空白
      },
      tabIndex: 0,
      isShowhistoryList: false,
    };
  },
  watch: {
    showTab() {
      const property = this.showTab === 'sale' ? this.sellProperty : this.showTab === 'rent' ? this.rentProperty : this.showTab === 'newestate' ? this.newProperty : this.estProperty;
      property.pageIndex = 1;
      property.list = [];
      property.loading = true;
      property.finished = false;
      this.onload(property);
    },
    immediate: true,
  },
  created() {
    // this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()));
    // if (this.isPc) {
    //   if (pub.getLang() === 'zh-cn') {
    //     location.href = `${pub.config.pcPassport}zh-cn/fav/`;
    //   } else if (pub.getLang() === 'en-us') {
    //     location.href = `${pub.config.pcPassport}en-us/fav/`;
    //   } else {
    //     location.href = `${pub.config.pcPassport}fav/`;
    //   }
    // } else {
    // }
    this.isShowPage = true;
    // let estateB = JSON.parse(sessionStorage.getItem("estate_switch"));
    // if(estateB == 1){
    //   this.estateButton = !this.estateButton;
    // }else{
    //   this.estateButton = this.estateButton;
    // }
    // console.log("this.$route.query.type",this.$route.query.type)
    this.showTab = this.$route.query.type === 'rent' ? 'rent' : this.$route.query.type === 'newestate' ? 'newestate' : this.$route.query.type === 'estate' ? 'estate' : 'sale';
    console.log('this.showTab', this.showTab);
    this.tabIndex = this.showTab === 'rent' ? 1 : this.showTab === 'newestate' ? 2 : this.showTab === 'estate' ? 3 : 0;
    if (this.$route.query.isBackRes == 1) {
      this.isShowhistoryList = true;
    } else {
      this.isShowhistoryList = false;
      this.colIndex = 0;
    }
  },
  methods: {
    handleTabClick(index, title) {
      console.log('index', index);
      console.log('title', title);
      if (index === 1 && title === this.lang.subscribe) {
        this.$router.push('/subscribe/');
      }
    },
    clickSale(index, title) {
      if (index === 0 && title === this.lang.esSale) {
        this.showTab = 'sale';
      }
      if (index === 1 && title === this.lang.rent) {
        this.showTab = 'rent';
      }
      if (index === 2 && title === this.lang.newSale) {
        this.showTab = 'newestate';
      }
      if (index === 3 && title === this.lang.estate) {
        this.showTab = 'estate';
      }
    },
    // 导航返回按钮
    onClickLeft() {
      if (!this.showClear) {
        if (this.$route.query.url) {
          window.location.href = location.origin + this.$route.query.url;
        } else if (this.$route.query.isBackRes == 1) {
          this.$router.go(-1);
        } else {
          this.$router.push('/');
        }
      }
    },

    // 下拉加载更多
    onload(property) {
      this.axios
        .post(this.pub.getApi().SearchCollection, {
          sourceType: this.showTab,
          pageIndex: property.pageIndex,
          pageCount: 15,
          isShowSourceInfo: true,
        })
        .then((res) => {
          if (res.data.code === 0 && res.data.result.data) {
            this.collectionListAll = res.data.result.data;
            if (property.pageIndex === 1) {
              if (res.data.result.count === 0) {
                property.showNull = true;
                property.clearText = '';
                return;
              }
              // debugger
              if (this.isShowPage && res.data.result.count > 0) {
                if (this.popupTimer) {
                  this.showBottom = false;
                  clearTimeout(this.popupTimer);
                }
                this.showBottom = true;
                this.popupTimer = setTimeout(() => {
                  this.showBottom = false;
                }, 3000);
                this.count =
                  this.lang.find +
                  res.data.result.count +
                  `${this.showTab == 'estate' ? this.lang.wuEst : this.showTab == 'rent' ? this.lang.propertiesRent : this.showTab == 'sale' ? this.lang.propertiesSale : this.lang.propertiesNew}`;
              }
              property.showNull = false;
              property.clearText = this.lang.clear;
            }
            property.list = property.list.concat(res.data.result.data);
            property.pageIndex++;
            property.loading = false;

            // 请求代理人列表
            if (this.showTab === 'sale' || this.showTab === 'rent') {
              this.propertyListId = property.list.map((item) => {
                return item.sourceID.toString();
              });
              this.axios
                .post(this.pub.getApi().GetPropertyUserInfoList, {
                  propertyIds: this.propertyListId,
                })
                .then((rem) => {
                  property.list = property.list.map((item, index) => {
                    return {
                      ...item,
                      ...rem.data.result[index],
                    };
                  });
                })
                .catch((err) => {});
            }

            if (property.list.length >= res.data.result.count) {
              property.finished = true;
            }
          }
        })
        .catch((err) => {});
    },
    // 清空收藏弹窗
    onClear() {
      this.showClear = true;
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        this.clearCollection();
        done();
      } else {
        done();
      }
    },
    //删除收藏
    clearCollection() {
      this.axios
        .get(this.pub.getApi().DeleteCollection, {
          params: {
            sourceType: this.showTab,
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            const property = this.showTab === 'sale' ? this.sellProperty : this.showTab === 'rent' ? this.rentProperty : this.showTab === 'estate' ? this.estProperty : this.newProperty;
            property.list = [];
            property.showNull = true;
            property.clearText = '';
          }
        })
        .catch((err) => {});
    },
    cancelCollection(id, index, type) {
      let type2 = type === 1 ? 'Sale' : type === 2 ? 'Rent' : type;
      let collectionID = null;
      if (type === 'new') {
        type2 = 'NewEstate';
        collectionID = id;
      } else if (type === 1 || type === 2) {
        const collectionItem = this.collectionListAll.find((item) => item.sourceID === id.property.propertyID);
        collectionID = collectionItem ? collectionItem.collectionID : null;
      } else {
        type2 = 'Estate';
        collectionID = id;
      }
      this.axios
        .get(this.pub.getApi().DeleteCollection, {
          params: {
            collectionId: collectionID,
            sourceType: type2,
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            if (type2 === 'NewEstate') {
              this.newProperty.list.splice(index, 1);
              if (!this.newProperty.list.length) {
                this.newProperty.showNull = true;
                this.newProperty.clearText = '';
              }
            } else if (type2 === 'Sale') {
              this.sellProperty.list.splice(index, 1);
              if (!this.sellProperty.list.length) {
                this.sellProperty.showNull = true;
                this.sellProperty.clearText = '';
              }
            } else if (type2 === 'Rent') {
              this.rentProperty.list.splice(index, 1);
              if (!this.rentProperty.list.length) {
                this.rentProperty.showNull = true;
                this.rentProperty.clearText = '';
              }
            } else {
              this.estProperty.list.splice(index, 1);
              if (!this.estProperty.list.length) {
                this.estProperty.showNull = true;
                this.estProperty.clearText = '';
              }
            }
          }
        });
    },
    canaddCollection(index, estateId, type) {
      const token = this.pub.getCookie('cEVaUDFrZ1kd0RA');
      if (token) {
        this.axios
          .post(this.pub.getApi().AddCollection, {
            sourceID: estateId,
            sourceType: type,
          })
          .then((res) => {
            this.sellProperty[index].list.collectionID = res.data.result;
            localStorage.setItem('NewHistoryList', JSON.stringify(this.NewHistoryList));
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* 导航 */
.col-header {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 44px;
  z-index: 4;
}

.col-header [class*='van-hairline']::after {
  border-bottom: 1px solid #e3e4e6;
}

.van-nav-bar {
  height: 44px;
  border-bottom: 1px solid #e3e4e6;
}

.van-nav-bar__title {
  font-size: 17px !important;
  font-weight: 700 !important;
  color: #333333 !important;
}

.van-nav-bar__text {
  height: 44px;
  font-size: 15px;
  color: #333333;
  padding: 0 12px;
}

.van-nav-bar .van-icon {
  color: #423f3f;
  font-size: 25px;
}

/* 没有记录 */
.none-record {
  width: 100%;
  height: calc(100vh - 135px);
  top: 44px;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #f5f6f7;
}

.none-record p {
  margin: 0;
  font-size: 15px;
  color: #333333;
}

.none_col {
  width: 120px;
  height: 120px;
  margin: 82px auto 0;
}

/* 点击清除出现蒙版 */
.popup-clear {
  background-color: rgba(0, 0, 0, 0.35);
  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  top: -44px;
  z-index: 300;
}
.vanPopupCount {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 60px;
  padding-left: 16px;
}

.content {
  display: flex;
  padding: 15px 16px 0;
  align-items: center;
  justify-content: space-between;

  .clear {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 14px;
    color: #999999;
    line-height: 18px;

    .clearIcon {
      width: 18px;
      height: 18px;
    }
  }

  .van-tabs {
    width: 80%;
    padding-top: 32px !important;

    ::v-deep .van-tabs__wrap {
      border-width: 0 !important;
      height: 32px !important;
    }

    ::v-deep .van-tab {
      padding: 0 !important;
      line-height: 32px !important;
      color: #999999;
    }

    ::v-deep .van-tabs__line {
      display: none;
    }

    ::v-deep .van-tab--active {
      background: #f4f4f4;
      border-radius: 4px;
      color: #333333;
      font-weight: 700;
    }
  }
}

::v-deep .van-tab--active {
  font-weight: 700;
}

::v-deep .van-tab {
  font-weight: 700;
}

::v-deep .van-hairline--top-bottom::after {
  border-width: 0;
}

::v-deep .van-tabs__wrap {
  border-width: 1px 0 !important;
  border: 0px solid #dddddd;
}
</style>
